import React, { ChangeEvent, KeyboardEvent } from 'react';
import { Card, CardHeader, CardContent, withStyles, WithStyles, createStyles, Theme, TextField, Button} from '@material-ui/core';
import {withRouter, Link} from 'react-router-dom';
import Auth from '@aws-amplify/auth';
import {  withTranslation, WithTranslation} from 'react-i18next';

interface  State 
{
    email: string;
    emailInvalid: boolean;
    password: string;
    passwordInvalid:boolean;
    password2: string;
    password2Invalid:boolean;
    state: string;
    valToken : string;

}
interface Props
{
}

class Signup extends React.Component<Props & WithTranslation & WithStyles,State>
{
    constructor(props:any)
    {
        super(props);
        this.state = {email: "",password:"",password2:"", state:"", valToken:"", emailInvalid:false, passwordInvalid:false, password2Invalid:false};
    }
    onChange = (field:string) => (ev : ChangeEvent<HTMLInputElement>) => {
        var o = {} as any; 
        o[field] = ev.target.value;
        this.setState(o);
    }

    onKeyPress = (ev: KeyboardEvent) => {
        if (ev.keyCode == 13)
        {
            if (this.state.state == "")
            {
                this.onCreate(null);
            }
            else if (this.state.state == "Validate")
            {
                this.onValidate(null);
            }
            else if (this.state.state == "NewPassword")
            {
                this.changePassword(null);
            }
        }
    }

    onForgotPassword =(ev : any) => {
        Auth.forgotPassword(this.state.email).then(data => {
            this.setState({state: "NewPassword"});
        }).catch(err => {
            alert(this.props.t("AN_ERROR_OCCURED") +": " + err.message);
        })
    }
    onResendValidation =(ev : any) => {
        Auth.resendSignUp(this.state.email).then(() => {
            this.setState({state:"Validate"});
        }).catch(e => {
           alert(this.props.t("AN_ERROR_OCCURED") +": " + e.message);
        });
    }

    changePassword =(ev : any) => {
        Auth.forgotPasswordSubmit(this.state.email, this.state.valToken,this.state.password)
        .then(data => console.log(data))
        .catch(err => alert(this.props.t("AN_ERROR_OCCURED") +": " + err.message));
    }

    onValidate =(ev : any) => {
        Auth.confirmSignUp(this.state.email, this.state.valToken, {
            forceAliasCreation: true    
        }).then(data => {
            //this.props.history.push('/myCourses');
            this.setState({state:"Validated"});
        }).catch(err =>  alert(this.props.t("AN_ERROR_OCCURED") +": " + err.message));
    }

    validateEmail(mail : string) 
    {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
        { 
            return true;
        }
        return false;
    }

    onCreate = (ev : any) =>
    {
        if (!this.validateEmail(this.state.email))
        {
            this.setState({emailInvalid:true});
            return;
        }
        this.setState({emailInvalid:false});
        if (this.state.password.length < 6)
        {
            this.setState({passwordInvalid:true});
            return;
        }
        this.setState({passwordInvalid:false});
        if (this.state.password2 != this.state.password)
        {
            this.setState({password2Invalid:true});
            return;
        }
        this.setState({password2Invalid:false});

        Auth.signUp({
            username: this.state.email,
            password: this.state.password,
            attributes: {
                email: this.state.email
            },
            validationData: []  //optional
            })
            .then(data => {
                this.setState({state: "Validate"});
            })
            .catch(err => {
                if (err.code == "UsernameExistsException")
                {
                    this.setState({state: "UserExists"});
                }
                else 
                {
                    alert(this.props.t("AN_ERROR_OCCURED_CREATING_ACCOUNT", { error: err.message}));
            }});
    }
    render()
    {
        let {classes,t} = this.props;
        return <div style={{margin:'10px 0'}}>
            <Card>
            <CardHeader className={classes.cardHeader} style={{color:'#FFF', padding: '3px'}}
            title={t('CREATE_ACCOUNT_HEADER')}/>
                <CardContent>
                    {this.state.state=="UserExists" &&
                    <div><p>{t("ACCOUNT_WITH_EMAIL_ALREADY_EXIST", {email: this.state.email})}</p>
                    <p><Button  variant="contained" color="primary" onClick={this.onForgotPassword}>{t("FORGOT_PASSWORD")}</Button> 
                    <Button  variant="contained" color="primary" onClick={this.onResendValidation}>{t("RESEND_VALIDATION_CODE")}</Button></p></div>
                }
                { this.state.state == "Validate" && 
                    <div>
                        <p>{t('STATE_VALIDATION_CODE')}</p>
                        <TextField label={t('VALIDATION_CODE')} onChange={this.onChange('valToken')} onKeyDown={this.onKeyPress} />
                        <Button  variant="contained" color="primary" onClick={this.onValidate}>{t('OK')}</Button> 
                    </div>
                }
                { this.state.state == "Validated" && 
                    <div>
                        <p>{t('ACCOUNT_CREATED')}</p>
                        <p><Link to="/">{t('ACCOUNT_CREATED_BACK_TO_STARTPAGE')}</Link></p>
                    </div>
                }
                {this.state.state == "" &&
                    <div>
                    <TextField label={t('EMAIL')} error={this.state.emailInvalid} helperText={this.state.emailInvalid ? t("INVALID_EMAIL") : ""}  onChange={this.onChange('email')} /><br/>
                    <TextField type={t('PASSWORD')} error={this.state.passwordInvalid} helperText={this.state.passwordInvalid ? t("PASSWORD_MIN_CHARACTERS") : ""}  label={t('PASSWORD')} onChange={this.onChange('password')} /><br/>
                    <TextField error={this.state.password2Invalid} helperText={this.state.password2Invalid ? t('PASSWORDS_DONT_MATCH') : ""} type="password"  label={t('REPEAT_PASSWORD')} onKeyDown={this.onKeyPress} onChange={this.onChange('password2')} /><br/>
                    <p><Button  variant="contained" color="primary" onClick={this.onCreate}>{t('CREATE_ACCOUNT')}</Button></p>
                    </div>
                }
                 {this.state.state == "NewPassword" &&
                    <div>
                        <p>{t('VALIDATION_CODE_SENT')}</p>
                    <TextField type="password"  label={t('NEW_PASSWORD')} onChange={this.onChange('password')} /><br/>
                    <TextField type="password" label={t('NEW_PASSWORD2')} onChange={this.onChange('password2')} /><br/>
                    <TextField  label={t('VALIDATION_CODE')} onChange={this.onChange('valToken')} onKeyDown={this.onKeyPress} /><br/>
                    <p><Button  variant="contained" color="primary" onClick={this.changePassword}>{t('CHANGE_PASSWORD')}</Button></p>
                    </div>
                }
              </CardContent>
            </Card>
        </div>
    }
}


const useStyles = ({ palette, spacing }: Theme) => createStyles({
  
    cardHeader: {
        backgroundColor: palette.primary.main
    }
});

export default withStyles(useStyles)(withRouter(withTranslation()(Signup) as any));